module.exports = __webpack_public_path__ + "img/youkexingweihuaxiang.a7e1211d.png";